import { getLoggedInStatus } from '@root/utils/cookies/cookies';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { fetcher } from '@/_lib/fetcher';
import { FullScribeUser } from '@/_types/Account';

export const ACCOUNT_QUERY_KEY = 'user-account';

export const getAccountQueryKey = () => [ACCOUNT_QUERY_KEY];

export const getAccount = async () => {
  return fetcher.get<FullScribeUser>('users/');
};

export const getAccountQueryOptions = () =>
  queryOptions({
    queryKey: getAccountQueryKey(),
    queryFn: getAccount,
    retry: 2
  });

export const useAccountQuery = () => {
  const { isLoggedIn } = getLoggedInStatus();

  return useQuery({
    ...getAccountQueryOptions(),
    enabled: isLoggedIn
  });
};
